export default {
  name: 'filterItem',
  component(filterId) {
    return {
      _filterId: filterId,
      get filter() {
        return this.$store.search.filters.find(f => f.id === this._filterId) || {};
      }
    };
  }
};
